export default __webpack_public_path__ + "static/media/todolist.bb385da7.mp4";